var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-back-wrapper ion-text-start ion-padding-start ion-padding-top"},[_c('img',{staticClass:"back-arrow icon-img",attrs:{"src":require("@/assets/icon-images/arrow-left.png")},on:{"click":_vm.back}})])}
var staticRenderFns = []

export { render, staticRenderFns }